/** The different endpoint actions available for the Amendment route. */
export enum AmendmentType {
  /** House Amendment */
  HAMDT = 'hamdt',

  /** Senate Amendment */
  SAMDT = 'samdt',

  /** Senate Unanimous Consent Amendment */
  SUAMDT = 'suamdt'
}
